var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64172 6.19971L10 10.458L17.3084 6.22468",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.008V10.4497",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27501 2.0665L3.82502 4.54153C2.81668 5.09986 1.9917 6.49985 1.9917 7.64985V12.3582C1.9917 13.5082 2.81668 14.9082 3.82502 15.4665L8.27501 17.9415C9.22501 18.4665 10.7833 18.4665 11.7333 17.9415L16.1834 15.4665C17.1917 14.9082 18.0167 13.5082 18.0167 12.3582V7.64985C18.0167 6.49985 17.1917 5.09986 16.1834 4.54153L11.7333 2.0665C10.775 1.53317 9.22501 1.53317 8.27501 2.0665Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 11.0332V7.98321L6.2583 3.4165",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOutlinedIcon);
export default __webpack_public_path__ + "static/media/boxOutlinedIcon.172324939a8ff3998b33576d5111c13f.svg";
export { ForwardRef as ReactComponent };